import React from "react";
import styles from "./BillingCard.module.css";
import Button from "@/components/forms/Button/Button";
import IconEdit from "@/components/icons/IconEdit";
import IconMastercard from "@/components/icons/IconMastercard";
import IconVisa from "@/components/icons/IconVisa";
import IconDiscover from "@/components/icons/IconDiscover";


export default function BillingCard({
  name = "Michael Auderer",
  cardType = "mastercard",
  lastFour = "2984",
  expirationMonth = "11",
  expirationYear = "2029",
  address = "8 The Green STE 4000",
  city = "Dover",
  state = "DE",
  zipCode = "19904",
  country = "United States",
  startedOn = "Oct 25, 2024 12:56 PM",
  onEdit = () => {},
}) {
  const getCardIcon = () => {
    switch (cardType.toLowerCase()) {
      case "visa":
        return <IconVisa />;
      case "mastercard":
        return <IconMastercard />;
      case "american express":
      case "discover":
        return <IconDiscover />;
    }
  };

  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <h2 className={styles.title}>Billing Information</h2>
        <Button type="secondary" onClick={onEdit} className={styles.editButton}>
          Edit <IconEdit />
        </Button>
      </div>

      <div className={styles.content}>
        <div className={styles.row}>
          <div className={styles.label}>Name:</div>
          <div className={styles.value}>{name}</div>
        </div>

        <div className={styles.row}>
          <div className={styles.label}>Credit Card:</div>
          <div className={styles.value}>
            <span className={styles.cardInfo}>
              {getCardIcon()} -{lastFour}
            </span>
          </div>
        </div>

        <div className={styles.row}>
          <div className={styles.label}>Expiration:</div>
          <div className={styles.value}>{expirationMonth}/{expirationYear.substring(2)}</div>
        </div>

        <div className={styles.row}>
          <div className={styles.label}>Address:</div>
          <div className={styles.value}>
            {address} {city}, {state} {zipCode} {country}
          </div>
        </div>

        <div className={styles.row}>
          <div className={styles.label}>Started On:</div>
          <div className={styles.value}>{startedOn}</div>
        </div>
      </div>
    </div>
  );
}